<template>
  <v-content align="center">
    <v-container fluid>
      <v-dialog
        v-model="dialog"
        v-if="editItem != null"
        presistent
        max-width="550"
        style="overflow-x: none"
      >
        <v-card>
          <v-card-title class="headline mb-2">
            {{ editItem.tag_namn }}
          </v-card-title>
          <v-container fluid class="align-center" style="max-width: 100%">
            <v-text-field
              v-model="editItem.benämning"
              label="Benämning"
              single-line
              hide-details
            ></v-text-field>
            <v-text-field
              v-model="editItem.individnummer"
              label="Individnummer"
              single-line
              hide-details
            ></v-text-field>
            <v-text-field
              v-model="editItem.artikelnummer"
              label="Artikelnummer"
              single-line
              hide-details
            ></v-text-field>

            <v-btn @click="saveItem" color="primary" class="mt-2" block
              >Spara</v-btn
            >
          </v-container>
        </v-card>
      </v-dialog>

      <v-card
        no-gutter
        style="width: 100% !important"
        class="align-center justify-center text-center"
      >
        <v-card-title class="headline mb-2">
          Dashboard
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-row class="mx-2">
          <v-col cols="12" md="6">
            <v-btn @click="toggleGroupby" color="primary" block>
              {{ groupby.length > 0 ? "Avgruppera" : "Gruppera" }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn @click="toggleAll" color="primary" block
              >Göm/visa grupper</v-btn
            >
          </v-col>
        </v-row>

        <div v-if="!loading">
          <v-data-table
            :headers="headers"
            :items="tags"
            :search="search"
            :loading="loading"
            item-key="id"
            :group-by="groupby"
            class="elevation-1"
            multi-sort
            dense
            disable-pagination
            hide-default-footer
            @click:row="handleClicked"
          >
            <template v-slot:group.header="{ items, isOpen, toggle }">
              <th colspan="100%">
                <v-btn
                  text
                  icon
                  small
                  color="white"
                  @click="toggle"
                  :ref="items[0].plats.toLowerCase()"
                >
                  <v-icon>{{ isOpen ? "mdi-minus" : "mdi-plus" }}</v-icon>
                </v-btn>
                <v-chip
                  small
                  :color="getColor(items[0].plats.toLowerCase())"
                  @click="toggle"
                >
                  <span class="mx-2 subtitle-1">
                    {{ items[0].plats.toUpperCase() }}
                  </span>
                </v-chip>

                <span class="mx-2 subtitle-1">
                  -
                  {{
                    gateways[items[0].plats.toLowerCase()] === undefined
                      ? 0
                      : gateways[items[0].plats.toLowerCase()].amount
                  }}
                  Sensorer
                </span>
              </th>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <v-progress-circular
            indeterminate
            color="amber"
          ></v-progress-circular>
        </div>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { format } from "date-fns";

export default {
  name: "Dashboard",
  data() {
    return {
      search: "",
      gateways: {},
      loading: true,
      groupby: ["plats"],
      dialog: false,
      editItem: null,
      headers: [
        { text: "Tag namn", value: "tag_namn" },
        { text: "Benämning", value: "benämning" },
        { text: "Individnummer", value: "individnummer" },
        { text: "Artikelnummer", value: "artikelnummer" },
        { text: "Batteristyrka", value: "batteristyrka" },
        { text: "Tid", value: "tid" },
        { text: "Plats", value: "plats" },
      ],
      baseUrl: process.env.VUE_APP_SO_API_BASE_URL,
    };
  },
  computed: {
    ...mapState("users", ["status", "currentUser"]),
    ...mapState("tag", ["tags", "gotthard"]),
    ...mapState("users", ["currentUser"]),
  },

  methods: {
    ...mapActions("tag", ["getTags", "getGotthardp", "updateTag"]),
    humanDate(date) {
      return date !== undefined
        ? format(new Date(date), "dd MMM - HH:mm")
        : "N/A";
    },

    toggleAll() {
      Object.keys(this.gateways).forEach((g) => {
        if (this.$refs[g] !== undefined) this.$refs[g].$el.click();
      });
    },

    toggleGroupby() {
      if (this.groupby.length > 0) {
        this.groupby = [];
      } else {
        this.groupby.push("plats");
      }
    },

    getColor(place) {
      if (this.gateways[place] === undefined) return "";
      return this.gateways[place].active ? "success" : "error";
    },

    handleClicked(item) {
      // Open dialog with the information from this item
      if (this.currentUser.email != "guest") {
        this.editItem = item;
        this.dialog = true;
      }
    },

    async saveItem() {
      await this.updateTag(this.editItem);
      this.dialog = false;
    },
  },

  async created() {
    if (!this.currentUser) this.$router.push("/login");

    await this.getTags();
    await this.getGotthardp();

    var gotthardGw = {};
    for (var g of this.gotthard) {
      if (g.name) {
        gotthardGw[g.name.toLowerCase()] = g.active;
      }
    }

    for (var t of this.tags) {
      let plts = t.plats.toLowerCase();
      if (this.gateways[plts] === undefined) {
        this.gateways[plts] = {
          amount: 0,
          lastActivity: undefined,
          active: false,
        };
      }

      this.gateways[plts].amount++;
      if (
        this.gateways[plts].lastActivity < t.tid ||
        this.gateways[plts].lastActivity === undefined
      ) {
        this.gateways[plts].lastActivity = t.tid;
        this.gateways[plts].active =
          gotthardGw[plts] != undefined ? gotthardGw[plts] : false;
      }

      gotthardGw[plts] = "PLATSDONE";
    }

    var validNames = [
      "ÖSH",
      "AVOS",
      "Nasta",
      "ITS Hallsberg 2",
      "Ellagro Handelsgatan",
      "Edman Sjöberg",
      "Mastec",
      "Kvarntorp",
      "Ellagro Nastagatan",
      "Edman Sjöberg2",
      "Wenmec",
      "Rolling Mill",
      "ITS Hallsberg",
      "Nacka",
    ];

    for (var ggw of this.gotthard) {
      if (
        ggw.name != null &&
        gotthardGw[ggw.name.toLowerCase()] !== "PLATSDONE" &&
        validNames.includes(ggw.name)
      ) {
        this.gateways[ggw.name.toLowerCase()] = {
          amount: 0,
          lastActivity: undefined,
          active:
            gotthardGw[ggw.name.toLowerCase()] != undefined
              ? gotthardGw[ggw.name.toLowerCase()]
              : false,
        };

        this.tags.push({ plats: ggw.name.toLowerCase() });
      }
    }

    this.loading = false;
  },

  components: {},
};
</script>

<style scoped></style>
